export const profilePictures = [
	require("../assets/images/submissionProfiles/Shiokko_Profile_1.png"),
	require("../assets/images/submissionProfiles/Shiokko_Profile_2.png"),
	require("../assets/images/submissionProfiles/Shiokko_Profile_3.png"),
	require("../assets/images/submissionProfiles/Shiokko_Profile_4.png"),
];
